"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.middlewareStateDataFormatter = exports.middlewareDataFormatter = exports.convertLineOptions = exports.convertDotPlotOptions = exports.convertBarChartOptions = exports.convertMapOptions = exports.getDataSeriesOptions = exports.middlewareMapDataToChartMapData = exports.middlewareDataToChartData = void 0;
const lodash_1 = __importDefault(require("lodash"));
const date_1 = require("./date");
const index_1 = require("./index");
const constants_1 = require("../charts/LineChart/constants");
const constants_2 = require("../charts/BarChart/constants");
const constants_3 = require("../charts/DotPlot/constants");
const ALL_STATE_METRIC_HEIGHT = 14;
const getMapDataSeriesOptions = function () {
  let metrics = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let data = arguments.length > 1 ? arguments[1] : undefined;
  let selectedStates = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  return metrics.flatMap(_ref => {
    let {
      id,
      states = []
    } = _ref;
    const metricFips = states.concat(selectedStates.map(fips => ({
      fips
    })));
    if (metricFips && metricFips.length) {
      return metricFips.map(function () {
        let {
          fips
        } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return {
          id: `${id}-${fips}`,
          geo_id: fips,
          strokeColor: 'black'
        };
      });
    }
    return {
      id: String(id)
    };
  });
};
const getSelectedLineId = highlightedArray => {
  if (highlightedArray && highlightedArray.length) {
    const firstHighlight = highlightedArray[0];
    const usSuffix = '-US';
    if (lodash_1.default.isString(firstHighlight) && firstHighlight.endsWith(usSuffix)) {
      return firstHighlight.substring(0, firstHighlight.length - usSuffix.length);
    }
    return firstHighlight;
  }
  return undefined;
};
function getAxisTypeFromData(data, keys, defaultVal) {
  const firstData = lodash_1.default.first(data);
  if (!firstData) {
    return defaultVal;
  }
  const key = keys.map(k => lodash_1.default.get(firstData, k, undefined)).find(k => k !== undefined);
  return !key || !(0, index_1.isValidAxisType)(key) ? defaultVal : key.toLowerCase();
}
const middlewareDataToChartData = function () {
  let {
    metric = {}
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    ...metric,
    id: metric.id && metric.geo_id && metric.geo_id !== 'US' ? `${metric.id}-${metric.geo_id}` : String(metric.id),
    data: metric.data.map(_ref2 => {
      let {
        value,
        rawKey
      } = _ref2;
      return {
        key: rawKey || false,
        value
      };
    }),
    x_type: metric.xType || metric.x_type,
    y_type: metric.yType || metric.y_type
  };
};
exports.middlewareDataToChartData = middlewareDataToChartData;
const middlewareMapDataToChartMapData = function () {
  let metrics = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  const firstMetric = metrics && metrics.length && metrics[0] && metrics[0].metric ? metrics[0].metric : {};
  return {
    ...firstMetric,
    datasets: metrics.map(exports.middlewareDataToChartData)
  };
};
exports.middlewareMapDataToChartMapData = middlewareMapDataToChartMapData;
const getDataSeriesOptions = function () {
  let metrics = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let data = arguments.length > 1 ? arguments[1] : undefined;
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const {
    primaryColor: chartPrimaryColor,
    lineSize: chartLineSize,
    annotations = []
  } = options;
  const hasStateData = data.some(function () {
    let {
      geo_id: geoID
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return geoID && geoID !== 'US';
  });
  return metrics.flatMap(_ref3 => {
    let {
      id,
      lineSize = chartLineSize,
      primaryColor = chartPrimaryColor,
      states,
      labelText,
      tooltipTitle,
      featured
    } = _ref3;
    if (states && states.length) {
      return states.map(function () {
        let {
          fips
        } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const stateAnnotations = annotations.filter(function () {
          let {
            metric
          } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          return String(metric) === `${id}-${fips}`;
        }).map(annotation => ({
          ...annotation,
          showTitleOnChart: annotation.showOnChart
        }));
        const datum = data.find(_ref4 => {
          let {
            id: dataID
          } = _ref4;
          return dataID === `${id}-${fips}`;
        });
        return {
          id: `${id}-${fips}`,
          lineWeight: lineSize,
          color: primaryColor,
          labelText: labelText || hasStateData && datum && datum.geo_name || datum.name,
          tooltipTitle: tooltipTitle || hasStateData && datum && datum.geo_name || datum.name,
          annotations: stateAnnotations,
          featured
        };
      });
    }
    const lineAnnotations = annotations.filter(function () {
      let {
        metric
      } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return String(metric) === String(id);
    }).map(annotation => ({
      ...annotation,
      key: annotation.key ? String(annotation.key) : '',
      showTitleOnChart: annotation.showOnChart
    }));
    const datum = data.find(_ref5 => {
      let {
        id: dataID
      } = _ref5;
      return dataID === String(id);
    });
    return {
      id: String(id),
      lineWeight: lineSize,
      color: primaryColor,
      labelText: labelText || hasStateData && datum && datum.geo_name || datum.name,
      tooltipTitle: tooltipTitle || hasStateData && datum && datum.geo_name || datum.name,
      annotations: lineAnnotations,
      featured
    };
  });
};
exports.getDataSeriesOptions = getDataSeriesOptions;
const convertMapOptions = function (_ref6) {
  let {
    title,
    subtitle,
    metrics,
    titleFontSize,
    subtitleFontSize,
    fontSize,
    startYear,
    startDate,
    selectedYear,
    chartSources,
    chartFootnotes,
    hideMetricsFootnotes,
    hideTitle,
    hideTooltip,
    hideTooltipYear,
    showSourcesAndFootnotes,
    hideYear,
    selectedStates,
    colourBins,
    centeredScale
  } = _ref6;
  let data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  const xType = getAxisTypeFromData(data, ['metric.xType', 'metric.x_type'], 'years');
  const yType = getAxisTypeFromData(data, ['metric.yType', 'metric.y_type'], 'linear');
  const selectedItem = selectedYear || startDate || startYear || undefined;
  return (0, index_1.removeUndefinedFromCollection)({
    showUSA: false,
    titleOptions: {
      text: hideTitle ? '' : title,
      fontSize: titleFontSize
    },
    subtitleOptions: {
      text: hideTitle ? '' : subtitle,
      fontSize: subtitleFontSize
    },
    footerOptions: {
      footnotes: chartFootnotes,
      sources: chartSources,
      show: showSourcesAndFootnotes,
      showMetricFootnotes: !hideMetricsFootnotes,
      fontSize
    },
    dropdownOptions: {
      selectedItem: selectedItem ? String(selectedItem) : undefined,
      show: !hideYear,
      type: xType.toLowerCase()
    },
    dataSeriesOptions: getMapDataSeriesOptions(metrics, data, selectedStates),
    tooltipOptions: {
      show: !hideTooltip,
      showSubtitle: !hideTooltipYear
    },
    keyType: yType.toLowerCase(),
    scaleOptions: {
      colorScale: colourBins,
      centeredScale,
      fontSize
    }
  });
};
exports.convertMapOptions = convertMapOptions;
const convertBarChartOptions = function (_ref7) {
  let {
    title,
    subtitle,
    metrics = [],
    topMetrics = [],
    titleFontSize,
    subtitleFontSize,
    fontSize,
    chartSources,
    chartFootnotes,
    hideMetricsFootnotes,
    axisTextColor,
    hideGridlines = true,
    hideTitle,
    hideTooltip,
    hideTooltipYear,
    showSourcesAndFootnotes,
    hideYear,
    primaryColor,
    sortRows,
    metricHeight,
    hideAxisLabels = true,
    selectedYear,
    selectedDropdown,
    domain = []
  } = _ref7;
  let data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  const xType = getAxisTypeFromData(data, ['xType', 'x_type'], constants_2.DEFAULT_X_TYPE);
  const yType = getAxisTypeFromData(data, ['yType', 'y_type'], constants_2.DEFAULT_DROPDOWN_TYPE);
  const hasAllStates = metrics.some(_ref8 => {
    let {
      allStates
    } = _ref8;
    return allStates;
  });
  return (0, index_1.removeUndefinedFromCollection)({
    titleOptions: {
      text: hideTitle ? '' : title,
      fontSize: titleFontSize
    },
    featuredPosition: 'top',
    subtitleOptions: {
      text: hideTitle ? '' : subtitle,
      fontSize: subtitleFontSize
    },
    footerOptions: {
      footnotes: chartFootnotes,
      sources: chartSources,
      show: showSourcesAndFootnotes,
      showMetricFootnotes: !hideMetricsFootnotes,
      fontSize
    },
    barOptions: {
      height: metricHeight || (hasAllStates ? ALL_STATE_METRIC_HEIGHT : undefined)
    },
    dropdownOptions: {
      selectedItem: selectedDropdown || selectedYear,
      show: !hideYear,
      type: xType
    },
    sort: sortRows !== false ? 'descending' : false,
    dataSeriesOptions: (0, exports.getDataSeriesOptions)(metrics.concat(topMetrics.map(metric => ({
      ...metric,
      featured: true
    }))), data, {
      primaryColor
    }),
    xAxisOptions: {
      textColor: axisTextColor,
      displayRangeMin: domain[0],
      displayRangeMax: domain[1],
      showGridlines: !hideGridlines,
      displayTicks: hideAxisLabels ? [] : ['top'],
      type: yType,
      fontSize
    },
    tooltipOptions: {
      show: !hideTooltip,
      showSubtitle: !hideTooltipYear
    },
    labelOptions: {
      fontSize
    }
  });
};
exports.convertBarChartOptions = convertBarChartOptions;
const convertDotPlotOptions = function (_ref9) {
  let {
    title,
    subtitle,
    metrics = [],
    topMetrics = [],
    titleFontSize,
    subtitleFontSize,
    fontSize,
    startYear,
    endYear,
    selectedYear2,
    startDate,
    endDate,
    selectedYear,
    chartSources,
    chartFootnotes,
    hideMetricsFootnotes,
    axisTextColor,
    hideGridlines,
    hideTitle,
    hideTooltip,
    hideTooltipYear,
    showSourcesAndFootnotes,
    hideYear,
    primaryColor,
    sortRows,
    metricHeight,
    hideAxisLabels,
    domain = []
  } = _ref9;
  let data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  const xType = getAxisTypeFromData(data, ['xType', 'x_type'], constants_3.DEFAULT_X_TYPE);
  const yType = getAxisTypeFromData(data, ['yType', 'y_type'], constants_3.DEFAULT_DROPDOWN_TYPE);
  const hasStateData = data.some(function () {
    let {
      geo_id: geoID
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return geoID && geoID !== 'US';
  });
  const hasAllStates = metrics.some(_ref10 => {
    let {
      allStates
    } = _ref10;
    return allStates;
  });
  const selectedItem1 = selectedYear || startDate || startYear || undefined;
  const selectedItem2 = selectedYear2 || endDate || endYear || undefined;
  return (0, index_1.removeUndefinedFromCollection)({
    titleOptions: {
      text: hideTitle ? '' : title,
      fontSize: titleFontSize
    },
    featuredPosition: 'top',
    subtitleOptions: {
      text: hideTitle ? '' : subtitle,
      fontSize: subtitleFontSize
    },
    footerOptions: {
      footnotes: chartFootnotes,
      sources: chartSources,
      show: showSourcesAndFootnotes,
      showMetricFootnotes: !hideMetricsFootnotes,
      fontSize
    },
    dataSeriesHeight: metricHeight || (hasAllStates ? ALL_STATE_METRIC_HEIGHT : undefined),
    dropdownOptions: {
      selectedItem1: selectedItem1 ? String(selectedItem1) : undefined,
      selectedItem2: selectedItem2 ? String(selectedItem2) : undefined,
      show: !hideYear,
      type: xType
    },
    sort: sortRows !== false ? 'descending' : false,
    dataSeriesOptions: [{
      metrics,
      overrides: {
        featured: false
      }
    }, {
      metrics: topMetrics,
      overrides: {
        featured: true
      }
    }].reduce((dso, _ref11) => {
      let {
        metrics,
        overrides
      } = _ref11;
      return dso.concat(metrics.map(m => {
        const datum = data.find(_ref12 => {
          let {
            id: dataID
          } = _ref12;
          return dataID === String(m.id);
        });
        return {
          id: m.id,
          dot2Color: primaryColor || m.primaryColor,
          labelText: m.labelText || hasStateData && datum && datum.geo_name || datum.name,
          tooltipTitle: m.tooltipTitle || hasStateData && datum && datum.geo_name || datum.name,
          selected: m.id === selectedItem1 || m.id === selectedItem2,
          ...overrides
        };
      }));
    }, []),
    dotOptions: {
      dot2Color: primaryColor
    },
    fontSize,
    xAxisOptions: {
      textColor: axisTextColor,
      showGridlines: !hideGridlines,
      displayTicks: hideAxisLabels ? [] : ['top'],
      displayRangeMin: domain[0],
      displayRangeMax: domain[1],
      type: yType,
      fontSize
    },
    tooltipOptions: {
      show: !hideTooltip,
      showSubtitle: !hideTooltipYear
    },
    labelOptions: {
      fontSize
    }
  });
};
exports.convertDotPlotOptions = convertDotPlotOptions;
const convertLineOptions = (_ref13, data) => {
  let {
    title,
    subtitle,
    metrics,
    titleFontSize,
    subtitleFontSize,
    fontSize,
    startYear,
    endYear,
    startDate,
    endDate,
    chartSources,
    chartFootnotes,
    hideMetricsFootnotes,
    axisTextColor,
    gridColor,
    hideGridlines,
    hideLineLabels,
    hideTitle,
    hideTooltip,
    hideTooltipYear,
    highlighted,
    showLegend,
    showSourcesAndFootnotes,
    showXGridlines,
    yDomain = [],
    areaFill,
    annotations,
    lineSize,
    primaryColor
  } = _ref13;
  const xType = getAxisTypeFromData(data, ['xType', 'x_type'], constants_1.DEFAULT_X_TYPE);
  const yType = getAxisTypeFromData(data, ['yType', 'y_type'], constants_1.DEFAULT_Y_TYPE);
  return (0, index_1.removeUndefinedFromCollection)({
    titleOptions: {
      text: hideTitle ? '' : title,
      fontSize: titleFontSize
    },
    subtitleOptions: {
      text: hideTitle ? '' : subtitle,
      fontSize: subtitleFontSize
    },
    dataSeriesOptions: (0, exports.getDataSeriesOptions)(metrics, data, {
      primaryColor,
      lineSize,
      annotations: annotations ? annotations.map(i => ({
        ...i,
        fontSize
      })) : []
    }),
    xAxisOptions: {
      textColor: axisTextColor,
      displayRangeMin: startDate || startYear,
      displayRangeMax: endDate || endYear,
      displayTicks: ['bottom'],
      type: xType,
      fontSize
    },
    yAxisOptions: {
      textColor: axisTextColor,
      displayTicks: ['left'],
      displayRangeMin: yDomain[0],
      displayRangeMax: yDomain[1],
      type: yType,
      fontSize
    },
    gridLineOptions: {
      color: gridColor,
      showVerticalLines: showXGridlines,
      showHorizontalLines: !hideGridlines
    },
    labelOptions: {
      show: (() => {
        if (hideLineLabels !== undefined) {
          return !hideLineLabels;
        }
        return showLegend === false ? true : undefined;
      })(),
      fontSize
    },
    tooltipOptions: {
      show: !hideTooltip,
      showSubtitle: !hideTooltipYear
    },
    selectedLineId: getSelectedLineId(highlighted),
    legendOptions: {
      show: showLegend,
      fontSize
    },
    footerOptions: {
      show: showSourcesAndFootnotes,
      sources: chartSources,
      footnotes: chartFootnotes,
      showMetricFootnotes: !hideMetricsFootnotes,
      fontSize
    },
    fillToOrigin: areaFill
  });
};
exports.convertLineOptions = convertLineOptions;
const middlewareDataFormatter = metric => {
  if (metric.datasets) {
    const data = metric.datasets[0];
    const xType = data.x_type || data.xType || data.xtype;
    return {
      metric: {
        ...metric,
        ...data,
        id: String(metric.id),
        xType,
        yType: data.y_type || data.yType || data.ytype,
        geo_name: data.geo_name || data.geoName,
        geo_id: data.geo_id || data.geoId,
        data: (0, lodash_1.default)(data.data).filter(_ref14 => {
          let {
            value
          } = _ref14;
          return value !== null;
        }).map(_ref15 => {
          let {
            key,
            ...rest
          } = _ref15;
          return {
            key: (0, date_1.dateParser)(key, xType),
            rawKey: key,
            ...rest
          };
        }).sortBy('key').value(),
        datasets: undefined
      }
    };
  }
  return {
    metric: {
      ...metric,
      id: String(metric.id),
      yType: metric.y_type || metric.yType || metric.ytype,
      xType: metric.x_type || metric.xType || metric.xtype,
      data: (0, lodash_1.default)(metric.data).filter(_ref16 => {
        let {
          value
        } = _ref16;
        return value !== null;
      }).map(_ref17 => {
        let {
          key,
          ...rest
        } = _ref17;
        return {
          key: (0, date_1.dateParser)(key, metric.x_type || metric.xType || metric.xtype),
          rawKey: key,
          ...rest
        };
      }).sortBy('key').value()
    }
  };
};
exports.middlewareDataFormatter = middlewareDataFormatter;
const middlewareStateDataFormatter = metric => {
  if (metric.datasets) {
    return metric.datasets.map(dataset => (0, exports.middlewareDataFormatter)({
      ...metric,
      datasets: [dataset]
    }));
  }
  return [];
};
exports.middlewareStateDataFormatter = middlewareStateDataFormatter;